<template>
  <router-view v-if="!loading"></router-view>
</template>

<script>

import headPath from '@/filter/headPath';
import { PASSPORT_CLIENT_SERVER, LESSONPLAY_TOKEN } from '@/config/url';

export default {
  name: "main-content",
  data() {
    return {
      userGuid: '',
      token: '',
      urlToken: '',

      platformType: '',
      icon_yuanxi: 'https://img.lessonplan.cn/IMG/yuanxi/icon.png',
      fromType: '',

      loading: true,
    }
  },
  components: {},


  async mounted() {
    const { type } = this.$route.params;
    if (!type) return this.$message.warning('未找到此类型平台');
    this.platformType = type;

    let { user, fromType } = this.$route.query;
    if (user == 'sharer') return this.sharerLogin();
    if (type == 'sz') fromType = 'yuanxi';
    this.fromType = fromType;

    this.urlToken = this.getURLToken();
    this.deleteURLToken();

    this.judegeMiniProgram();
  },
  methods: {
    //检查是否在小程序中
    async judegeMiniProgram() {
      const isMiniProgram = await this.$api.passport.checkInMiniProgram();
      this.isMiniProgram = isMiniProgram;

      if (isMiniProgram && this.urlToken) {
        const ret = await this.$api.passport.verifyToken({ token: this.urlToken })
        if (ret.status === 1) {
          this.userGuid = ret.userGuid;
          this.loadFunction();
          return
        }
      }
      this.judgeToken();
    },
    //判断token
    async judgeToken() {
      const token = window.localStorage.getItem(LESSONPLAY_TOKEN);

      const herfurl = encodeURIComponent(location.href);
      //localStorage中不存在token时，先尝试从URL中获取token
      if (!token) {
        //URL中也不存在token，跳转到认证中心检查（其他应用）是否已经登录过
        if (!this.urlToken) {
          this.$store.commit('userInfo', null);

          if (this.fromType == 'yuanxi') location.href = `${PASSPORT_CLIENT_SERVER}/yuanxi?redirectURI=${herfurl}`;
          else location.href = `${PASSPORT_CLIENT_SERVER}/shell/${this.platformType}?redirectURI=${herfurl}`;
        }
        //URL中存在token，验证该token的有效性（这种情况一般发生在首次登录）
        else {
          const ret = await this.$api.unifydata.verifyToken({ token: this.urlToken })

          //URL中的token有效，将该token写入localStorage并删除URL中的token
          if (ret.statusCode === 200) {
            window.localStorage.setItem(LESSONPLAY_TOKEN, this.urlToken);

            this.userGuid = ret.data.userGuid;
            this.token = ret.data.token;
          }
          //URL中的token无效，删除URL中的token并跳转到登录页（这种情况一般是用户手动在URL后面添加了token参数）
          else {
            this.$store.commit('userInfo', null);

            if (this.fromType == 'yuanxi') location.href = `${PASSPORT_CLIENT_SERVER}/yuanxi?redirectURI=${herfurl}`;
            else location.href = `${PASSPORT_CLIENT_SERVER}/shell/${this.platformType}?redirectURI=${herfurl}`;
          }
        }
      }
      //localStorage中存在token时，验证该token的有效性
      else {
        const ret = await this.$api.unifydata.verifyToken({ token });
        //localStorage中的token有效
        if (ret.statusCode === 200) {
          this.userGuid = ret.data.userGuid;
          this.token = ret.data.token;
        }
        //localStorage中的token无效，清除该token并跳转到认证中心检查（其他应用）是否已经登录过
        else {
          window.localStorage.removeItem(LESSONPLAY_TOKEN)
          location.href = `${PASSPORT_CLIENT_SERVER}/auth/checkTouristLogin?redirectURI=${herfurl}`
        }
      }
      this.loadFunction();
    },
    //删除URL中的token
    deleteURLToken() {
      const searchParams = new URLSearchParams(location.search)
      searchParams.delete('token')
      const newURL = searchParams.toString() ? `${location.pathname}?${searchParams.toString()} ` : location.pathname
      history.pushState({}, '', newURL)
    },
    //获取URL中的token
    getURLToken() {
      const search = new URLSearchParams(location.search)
      const urlToken = search.get('token')
      return urlToken
    },
    //测试账号登陆
    async sharerLogin() {
      const ret = await this.$api.unifydata.sharerLogin();

      this.userGuid = ret.data.userGuid;
      this.token = ret.data.token;
      window.localStorage.setItem(LESSONPLAY_TOKEN, this.token);
      this.$store.commit('isSharer', true);

      this.loadFunction();
    },
    //获取用户信息
    async loadFunction() {
      let user = await this.$api.unifydata.getStudent({ userGuid: this.userGuid }).then(res => res.data);
      if (user) {
        user.HeadPhotoPath = headPath(user.HeadPhotoPath);
        user.Name = user.NickName || user.Name;
        user.token = this.token;
      }
      this.$store.commit('userInfo', user);
      //获取所有成就
      let allAchievementList = await this.$api.unifydata.getAllAchievement().then(res => res.data || []);
      this.$store.commit('allAchievementList', allAchievementList);

      this.getPlatformInfo();
    },
    //获取平台信息
    async getPlatformInfo() {
      let platformType = this.platformType;
      let res = await this.$api.unifydata.getPlatformInfo(platformType);
      if (res.statusCode != 200 || !res.data) {
        this.loading = false
        return this.$message.error(res.message);
      }
      let platform = res.data;
      let { pageConfig } = platform;
      let page_content = {};

      if (!pageConfig || !pageConfig.page_list || pageConfig.page_list.length == 0) return this.loading = false;
      pageConfig.page_list.forEach(page => {
        if (page.content && page.content.length > 0) {
          page_content[page.type] = {};
          page.content.forEach(item => {
            page_content[page.type][item.type] = item.value;
          })
        }
      });
      platform.page_content = page_content;
      if (platformType != 'sz') document.title = platform.Name;

      let { fromType } = this.$route.query;
      if (platformType == 'sz') fromType = 'yuanxi';
      if (platformType == 'train') fromType = 'train';
      this.$store.commit('fromType', fromType);

      if (fromType == 'yuanxi') this.changeFavicon(this.icon_yuanxi);
      else if (pageConfig.logo) this.changeFavicon(pageConfig.logo);

      this.$store.commit('platform', platform);

      this.loading = false;

      $('#app').css('background-color', pageConfig.theme_color);
      if (this.isDark(pageConfig.theme_color)) $('#app').addClass('dark-theme');
      if (this.$route.path === `/${platformType}`) this.$router.push(`/${platformType}/classList`);
    },
    //是否深色
    isDark(color) {
      const r = parseInt(color.slice(1, 3), 16);
      const g = parseInt(color.slice(3, 5), 16);
      const b = parseInt(color.slice(5, 7), 16);
      const luminance = (0.2126 * r + 0.7152 * g + 0.0722 * b);
      return luminance < 128;
    },
    //修改标签图标
    changeFavicon(link) {
      let $favicon = document.createElement("link");
      $favicon.rel = "icon";
      $favicon.href = link;
      document.head.appendChild($favicon);
    }
  }
};
</script>
